import { ResumeContext } from "../../pages/user_center/contents/my_resume/ResumeProvider";
import { useContext } from "react";

function useResumeService() {
  const service = useContext(ResumeContext);

  return service;
}

export default useResumeService;
